function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { delimiter } from '../modules/core/regex.js';
import SVGArray from './SVGArray.js';
import Box from './Box.js';
import Matrix from './Matrix.js';
var PointArray = /*#__PURE__*/ function(SVGArray) {
    "use strict";
    _inherits(PointArray, SVGArray);
    function PointArray() {
        _class_call_check(this, PointArray);
        return _call_super(this, PointArray, arguments);
    }
    _create_class(PointArray, [
        {
            // Get bounding box of points
            key: "bbox",
            value: function bbox() {
                var maxX = -Infinity;
                var maxY = -Infinity;
                var minX = Infinity;
                var minY = Infinity;
                this.forEach(function(el) {
                    maxX = Math.max(el[0], maxX);
                    maxY = Math.max(el[1], maxY);
                    minX = Math.min(el[0], minX);
                    minY = Math.min(el[1], minY);
                });
                return new Box(minX, minY, maxX - minX, maxY - minY);
            }
        },
        {
            // Move point string
            key: "move",
            value: function move(x, y) {
                var box = this.bbox();
                // get relative offset
                x -= box.x;
                y -= box.y;
                // move every point
                if (!isNaN(x) && !isNaN(y)) {
                    for(var i = this.length - 1; i >= 0; i--){
                        this[i] = [
                            this[i][0] + x,
                            this[i][1] + y
                        ];
                    }
                }
                return this;
            }
        },
        {
            // Parse point string and flat array
            key: "parse",
            value: function parse() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
                    0,
                    0
                ];
                var points = [];
                // if it is an array, we flatten it and therefore clone it to 1 depths
                if (_instanceof(array, Array)) {
                    array = Array.prototype.concat.apply([], array);
                } else {
                    // Else, it is considered as a string
                    // parse points
                    array = array.trim().split(delimiter).map(parseFloat);
                }
                // validate points - https://svgwg.org/svg2-draft/shapes.html#DataTypePoints
                // Odd number of coordinates is an error. In such cases, drop the last odd coordinate.
                if (array.length % 2 !== 0) array.pop();
                // wrap points in two-tuples
                for(var i = 0, len = array.length; i < len; i = i + 2){
                    points.push([
                        array[i],
                        array[i + 1]
                    ]);
                }
                return points;
            }
        },
        {
            // Resize poly string
            key: "size",
            value: function size(width, height) {
                var i;
                var box = this.bbox();
                // recalculate position of all points according to new size
                for(i = this.length - 1; i >= 0; i--){
                    if (box.width) this[i][0] = (this[i][0] - box.x) * width / box.width + box.x;
                    if (box.height) this[i][1] = (this[i][1] - box.y) * height / box.height + box.y;
                }
                return this;
            }
        },
        {
            // Convert array to line object
            key: "toLine",
            value: function toLine() {
                return {
                    x1: this[0][0],
                    y1: this[0][1],
                    x2: this[1][0],
                    y2: this[1][1]
                };
            }
        },
        {
            // Convert array to string
            key: "toString",
            value: function toString() {
                var array = [];
                // convert to a poly point string
                for(var i = 0, il = this.length; i < il; i++){
                    array.push(this[i].join(','));
                }
                return array.join(' ');
            }
        },
        {
            key: "transform",
            value: function transform(m) {
                return this.clone().transformO(m);
            }
        },
        {
            // transform points with matrix (similar to Point.transform)
            key: "transformO",
            value: function transformO(m) {
                if (!Matrix.isMatrixLike(m)) {
                    m = new Matrix(m);
                }
                for(var i = this.length; i--;){
                    // Perform the matrix multiplication
                    var _this_i = _sliced_to_array(this[i], 2), x = _this_i[0], y = _this_i[1];
                    this[i][0] = m.a * x + m.c * y + m.e;
                    this[i][1] = m.b * x + m.d * y + m.f;
                }
                return this;
            }
        }
    ]);
    return PointArray;
}(SVGArray);
export { PointArray as default };
